import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { EmployerContributionStatusType, LayDcPlanAdoptionContentModel, LayDcPlanFormModel } from '../../models/plan-adoption-form-models';
import { LayDcQuestionsWizard } from '../lay-dc/lay-dc-questions-wizard';

export class RsvpQuestionsWizard extends LayDcQuestionsWizard {    

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();

        return {
            ...content,            
            gpsType: GpsType.RsvpAdoptionQuestions,
            pageTitle: institutionSettings?.qccoLayRsvpTitle,
            PageDescription: institutionSettings?.qccoRsvpDescription,
            submitLabel: institutionSettings?.qccoQuestionSubmitLabel,
            cancelLabel: institutionSettings?.qccoQuestionCancelLabel,
        };
    }       

    // eslint-disable-next-line class-methods-use-this
    getDefaultFormValues(): LayDcPlanFormModel {
        const initialValues: LayDcPlanFormModel = {
            qccoQuestion1: '',
            qccoQuestion2: '',
            qccoQuestion3: '',
            minimum_scheduleds_hours: 1000,
            employer_contribution_status: EmployerContributionStatusType.Scheduled,
            employer_base_contribution_amount: 0,
            employer_base_contribution_percentage: 0,
            employer_match_contribution_amount: 0,
            employer_match_contribution_percentage: 0,
            allow_multiple_contributions: false,
            participants: [
                {
                    id: 0,
                },
                {
                    id: 1,
                },
                {
                    id: 2,
                },
                {
                    id: 3,
                },
                {
                    id: 4,
                },
            ],
            default_bill_payor: '',
            adoption_date: '',
            member_type: null,
        };

        return initialValues;
    }
}